import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["getRowId", "boxShadow", "columns", "rows", "onRowClick", "rowCount", "pageSize", "setPageSize", "setPage", "sx", "className", "onSortChange", "editMode", "disableColumnFilter", "showColumnVerticalBorder", "showCellVerticalBorder", "onRowEditStart", "border", "hideFooterSelectedRowCount", "hideFooterPagination", "onPaginationModelChange", "paginationModel", "disableSelectionOnClick", "paginationMode", "sortingMode"];
import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { DataGridPremium
// gridPageCountSelector,
// gridPageSelector,
// useGridApiContext,
// useGridSelector,
 } from "@mui/x-data-grid-premium";
import { t } from "i18next";
var Root = styled(DataGridPremium)(function (_ref) {
    var theme = _ref.theme;
    return {};
});
export var MuiDataGridComponent = function (props) {
    var getRowId = props.getRowId, _a = props.boxShadow, boxShadow = _a === void 0 ? 0 : _a, columns = props.columns, rows = props.rows, onRowClick = props.onRowClick, rowCount = props.rowCount, pageSize = props.pageSize, setPageSize = props.setPageSize, setPage = props.setPage, sx = props.sx, className = props.className, onSortChange = props.onSortChange, editMode = props.editMode, _b = props.disableColumnFilter, disableColumnFilter = _b === void 0 ? true : _b, _c = props.showColumnVerticalBorder, showColumnVerticalBorder = _c === void 0 ? true : _c, _d = props.showCellVerticalBorder, showCellVerticalBorder = _d === void 0 ? true : _d, onRowEditStart = props.onRowEditStart, _e = props.border, border = _e === void 0 ? "1px solid rgba(217, 217, 217, 1)" : _e, _f = props.hideFooterSelectedRowCount, hideFooterSelectedRowCount = _f === void 0 ? true : _f, _g = props.hideFooterPagination, hideFooterPagination = _g === void 0 ? true : _g, onPaginationModelChange = props.onPaginationModelChange, paginationModel = props.paginationModel, _h = props.disableSelectionOnClick, disableSelectionOnClick = _h === void 0 ? true : _h, paginationMode = props.paginationMode, sortingMode = props.sortingMode, other = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/ React.createElement(Root, _extends({
        getRowId: getRowId,
        onRowClick: onRowClick,
        className: className ? className : Root,
        rows: rows,
        columns: columns,
        rowCount: rowCount ? rowCount : rows ? rows === null || rows === void 0 ? void 0 : rows.length : 0,
        paginationMode: paginationMode || "server",
        sortingMode: sortingMode || "server",
        autoPageSize: false,
        initialState: {
            pagination: {
                paginationModel: {
                    pageSize: 10,
                    page: 0
                }
            }
        },
        pageSizeOptions: [5, 10, 20, 50, 100],
        onPaginationModelChange: onPaginationModelChange,
        onSortModelChange: onSortChange,
        slotProps: {
            // pagination: CustomPagination,
            columnSortedDescendingIcon: SortedDescendingIcon,
            columnSortedAscendingIcon: SortedAscendingIcon,
            noRowsOverlay: NoRowsOverlay
        },
        sx: sx,
        rowHeight: 40,
        columnHeaderHeight: 40,
        disableColumnMenu: true,
        disableColumnSelector: true
        /// disableColumnFilter={disableColumnFilter}
        ,
        showColumnVerticalBorder: showColumnVerticalBorder,
        showCellVerticalBorder: showCellVerticalBorder,
        hideFooterSelectedRowCount: hideFooterSelectedRowCount,
        hideFooterPagination: hideFooterPagination,
        disableSelectionOnClick: true
    }, other));
};
// const CustomPagination = () => {
//     const apiRef = useGridApiContext();
//     const page = useGridSelector(apiRef, gridPageSelector);
//     const pageCount = useGridSelector(apiRef, gridPageCountSelector);
//     return (
//         <Stack spacing={2}>
//             <Pagination
//                 color="primary"
//                 count={pageCount}
//                 defaultPage={6}
//                 page={page + 1}
//                 // onChange={(event, value) => apiRef.current.setPage(value - 1)}
//                 renderItem={(item) => (
//                     <PaginationItem
//                         component={Button}
//                         // to={`/inbox${item.page === 1 ? "" : `?page=${item.page}`}`}
//                         {...item}
//                     />
//                 )}
//             />
//         </Stack>
//     );
// };
export function NoRowsOverlay() {
    return /*#__PURE__*/ React.createElement(Stack, {
        height: "100%",
        alignItems: "center",
        justifyContent: "center"
    }, t("No data found"));
}
export function SortedDescendingIcon() {
    return /*#__PURE__*/ React.createElement("span", {
        className: "icon"
    });
}
export function SortedAscendingIcon() {
    return /*#__PURE__*/ React.createElement("span", {
        className: "icon"
    });
}
